export default "__VITE_ASSET__CotrFRwm__"